import React, { useState } from 'react';
import { useLoading } from '../../contexts/LoadingContext';

const CenteredLoader = () => {
  const { isGlobalLoading } = useLoading();
  const [isHovered, setIsHovered] = useState(false);

  if (!isGlobalLoading) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-95 backdrop-blur-sm"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="text-center">
        <div className="flex justify-center space-x-2 mb-4">
          <div className="w-4 h-4 bg-gray-600 rounded-full animate-pulse"></div>
          <div className="w-4 h-4 bg-gray-600 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
          <div className="w-4 h-4 bg-gray-600 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
        </div>
        
        <h3 className="text-lg font-semibold text-gray-800 mb-2">
          Chargement en cours...
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          Veuillez patienter pendant que nous récupérons vos données
        </p>
        
        {isHovered && (
          <p className="text-xs text-gray-500 bg-white bg-opacity-80 px-3 py-1 rounded-full inline-block">
            👆 Survolez pour voir la page web
          </p>
        )}
      </div>
    </div>
  );
};

export default CenteredLoader; 